import * as React from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';

import { Heading } from '@restworld/ui-ds-base';

import { workerCertificatesAtom } from '../../../../employer-job-listing.atoms';
import { StyledSeparator } from './worker-experience';
import { CertificationSectionItem } from './certification-section-item';
import { TabCardWrapper } from '../candidate-profile-section';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICertificationSectionProps {}

const CertificationSection: React.FunctionComponent<ICertificationSectionProps> = (props) => {
  const workerCertificates = useAtomValue(workerCertificatesAtom);
  const itemsCount = workerCertificates?.length || 0;
  const { t } = useTranslation('onboarding-page');
  return (
    <TabCardWrapper title={t('certificate')}>
      <div className="flex flex-col items-start pt-4">
        {workerCertificates?.map((workerCertificate, index) => (
          <div className="w-full" key={index} id={`certifications-${index}`}>
            <CertificationSectionItem key={index} {...{ workerCertificate, workerCertificateIndex: index }} />
            {index < itemsCount - 1 && <StyledSeparator />}
          </div>
        ))}
        {!workerCertificates?.length && (
          <Heading size={5} weight="normal" color="muted">
            {t('missing_info')}
          </Heading>
        )}
      </div>
    </TabCardWrapper>
  );
};

export default CertificationSection;
